export function Spinner({
  className,
  size = 16,
}: {
  className?: string;
  size?: number;
}) {
  const strokeWidth = Math.ceil(size / 8);
  const radius = Math.ceil((size - strokeWidth) / 2);
  const perimeter = radius * Math.PI * 2;

  return (
    <svg
      className={`spinner ${className}`}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
    >
      <circle
        className="spinner track"
        cx="50%"
        cy="50%"
        fill="none"
        r={radius}
        stroke="var(--color-neutral-000-full)"
        strokeWidth={strokeWidth}
        opacity={0.5}
      />
      <circle
        className="spinner indicator"
        cx="50%"
        cy="50%"
        fill="none"
        r={radius}
        stroke="var(--color-neutral-000-full)"
        strokeDasharray={`${perimeter * 0.25} ${perimeter * 0.75}`}
        strokeWidth={strokeWidth}
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          values={`0 ${size / 2} ${size / 2};360 ${size / 2} ${size / 2}`}
          keyTimes="0;1"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
}
